export default __webpack_public_path__ + "static/media/full2.2e6b6eca.jpg";